import React, { useState, useEffect, useRef } from 'react';
import { KTSVG, SimpleAlert } from '../../../../../_mexablock/helpers';
import { Modal } from 'react-bootstrap-v5';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { statusSelectModalStyles } from '../models/statusSelectStyles';
import {
  createPackMovement,
  downloadPackageReportPDF,
  downloadPackageReportZip,
  getSelectMotive,
  getStockPackage,
  updatePackMovement,
} from '../../../../service/inventario/entrada&salidas';
import { getMe } from '../../../../service/users/Usuarios';
import { StepperComponent } from '../../../../../_mexablock/assets/ts/components';
import Stepper from '../../../../../_mexablock/helpers/components/Stepper';
import AnimationSucces from '../../../../../_mexablock/helpers/components/SuccesResponse';
import Select from 'react-select';
import { ConfirmModal } from './ConfirmModal';

type Props = {
  show: boolean;
  handleClose: (updateGrid: boolean) => void;
  handleRefresh: (updateGrid: boolean) => void;
  data: any;
};

const stepperHeaders = ['Detalles de devolución', 'Completado'];

const PackMovementSchema = Yup.object().shape({
  is_output: Yup.mixed().required('Seleccione acción.'),
  motive_id: Yup.number()
    .min(1, 'Razón requerida.')
    .required('Seleccione tipo.'),
  detail: Yup.string().required('Motivo requerido.'),
});

const currentDate = new Date();
const fechaMaxima = new Date(currentDate);
fechaMaxima.setFullYear(currentDate.getFullYear() - 18);

const DevolverModal: React.FC<Props> = ({
  show,
  data,
  handleClose,
  handleRefresh,
}) => {
  const [loading, setLoading] = useState(false);
  const [initValues, setInitValues] = useState<{
    is_output: boolean;
    movement_id: string;
    motive_id: number;
    original_location: string;
    current_location: string;
    detail: string;
    stock: number[];
  }>({
    is_output: false,
    movement_id: '',
    motive_id: 0,
    original_location: '',
    current_location: '',
    detail: '',
    stock: [],
  });

  const stepper = useRef<StepperComponent | null>(null);
  const [textStepper, setTextStepper] = useState('Continuar');
  const [selectedOptionMov, setSelectedOptionMov] = useState<{
    value: number;
    label: string;
  } | null>({ value: 14, label: 'Devolver' });
  const [typeMovOptions, setTypeMovOptions] = useState<
    { value: number; label: string; status_id: number }[]
  >([]);
  const [dataInventario, setDataInventario] = useState<any[]>([]);
  const [filteredProducts, setFilteredProducts] = useState<any[]>([]);
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [responseConfirm, setResponseConfirm] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [filteredMovOptions, setFilteredMovOptions] = useState<
    { value: number; label: string; status_id: number }[]
  >([]);
  const [packageDate, setPackageDate] = useState<string>('');
  const [totalCost, setTotalCost] = useState<number>(0);
  const [user, setUser] = useState<any>();
  const typeActionsOptions = [
    { value: 14, label: 'Devolver' },
    { value: 11, label: 'Asignar' },
  ];

  const formPackMovement = useFormik({
    initialValues: initValues,
    validationSchema: PackMovementSchema,
    enableReinitialize: true,
    onSubmit: (values, { setStatus, setSubmitting, setFieldError }) => {
      setLoading(true);
      const curIndex = stepper.current?.currentStepIndex;
      switch (curIndex) {
        case 1:
          if (selectedItems.length === 0) {
            SimpleAlert(
              'No se ha seleccionado ningún artículo del inventario',
              3000,
              'error'
            );
            setSubmitting(false);
            setLoading(false);
            return;
          }
          const numericSelectedItems = selectedItems.map((id) => Number(id));
          values.stock = numericSelectedItems;

          updatePackMovement(values)
            .then((res) => {
              if (res) {
                stepper.current?.goNext();
                handleRefresh(true);
                setLoading(false);
              }
            })
            .catch((err) => {
              let resMessageToast: string = 'Ocurrió un error inesperado.';
              if (err.response && err.response.data) {
                const { message, details = null } = err.response.data;
                resMessageToast = `${message}`;
                if (details && Array.isArray(details) && details.length) {
                  resMessageToast = `${details[0].message}`;
                }
              } else if (err.message) {
                resMessageToast = err.message;
              }
              setLoading(false);
              setSubmitting(false);
              SimpleAlert(resMessageToast, 3000, 'error');
            })
            .finally(() => {
              setLoading(false);
            });
          break;
        case 2:
          stepper.current?.goNext();
          break;
        case 3:
          onClose();
          break;
      }
    },
  });

  const fetchPostMotive = async () => {
    try {
      const res = await getSelectMotive();
      if (res) {
        setTypeMovOptions(res);
        const filtered = res.filter((item: any) => item.status_id === 14);
        setFilteredMovOptions(filtered);
      }
    } catch (error: any) {
      let resMessageToast: string = '';
      const {
        data: { message, details = null },
      } = error.response;
      resMessageToast = `${message}`;
      if (details?.length) {
        resMessageToast = `${details[0].message}`;
      }
      SimpleAlert(resMessageToast, 3000, 'error');
    }
  };

  const fetchPostUser = async () => {
    const data = await getMe();
    const formattedUser = {
      ...data,
      full_name: `${data.first_name || ''} ${
        data.father_last_name || ''
      }m`.trim(),
    };
    setUser(formattedUser);
  };

  // const fetchPostIccid = async (idPackage: number) => {
  //   const filters = {
  //     package_id: idPackage,
  //   };

  //   try {
  //     const sends = await getPackageById(filters);
  //     if (sends) {
  //       setDataInventario(sends);
  //       const filtered = sends.filter((item: any) => item.status_id === 9);
  //       setFilteredProducts(filtered);
  //     }
  //   } catch (error) {
  //     console.error('Error al obtener datos:', error);
  //   }
  // };

  const fetchPostIccid = async (idPackage: number) => {
    try {
      const sends = await getStockPackage(idPackage);
      if (sends) {
        setDataInventario(sends);
        setFilteredProducts(sends);
      }
    } catch (error) {
      console.error('Error al obtener datos:', error);
    }
  };

  const handleSearch = (value: string) => {
    setSearchTerm(value);

    if (!value.trim()) {
      setFilteredProducts(dataInventario);
    } else {
      const filtered = dataInventario.filter(
        (item) =>
          item?.stock?.iccid &&
          item.stock.iccid.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredProducts(filtered);
    }
  };

  const toggleSelection = (id: string) => {
    const item = filteredProducts.find((p) => p.id === id);
    if (item?.disabled) return;

    if (selectedItems.includes(id)) {
      setSelectedItems(selectedItems.filter((item) => item !== id));
    } else {
      setSelectedItems([...selectedItems, id]);
    }
  };

  const handleSelectAll = () => {
    const selectableIds = filteredProducts
      .filter((item) => !item.disabled)
      .map((item) => item.id);

    if (
      selectedItems.length === selectableIds.length &&
      selectableIds.length > 0
    ) {
      setSelectedItems([]);
    } else {
      setSelectedItems(selectableIds);
    }
  };

  const handleCustomerChangeMov = (selected: any) => {
    if (selected) {
      formPackMovement.setFieldValue('motive_id', selected.value);
    } else {
      formPackMovement.setFieldValue('motive_id', 0);
    }
  };

  const handleCustomerChangeType = (
    selected: { value: number; label: string } | null
  ) => {
    if (selected) {
      setSelectedOptionMov(selected);
      if (selected.value === 14) {
        formPackMovement.setFieldValue('is_output', false);
      }
    }
  };

  const onClose = () => {
    formPackMovement.resetForm();
    setDataInventario([]);
    setFilteredProducts([]);
    setSearchTerm('');
    setSelectedItems([]);
    setSelectedOptionMov(null);
    setFilteredMovOptions([]);
    setTotalCost(0);
    setUser(null);
    setPackageDate('');
    setTextStepper('Continuar');
    handleClose(false);
  };

  useEffect(() => {
    if (show) {
      fetchPostMotive();
      fetchPostUser();
      fetchPostIccid(data?.id);
      setSelectedOptionMov({ value: 14, label: 'Devolver' });
      formPackMovement.setFieldValue('is_output', false);
      const today = new Date();
      const formattedToday = today.toLocaleDateString('es-ES');
      setPackageDate(formattedToday);
      if (data?.id) {
        formPackMovement.setFieldValue('movement_id', data.id);
      }
    }
  }, [show]);

  useEffect(() => {
    const selectedObjects = filteredProducts.filter((item) =>
      selectedItems.includes(item.id)
    );

    const sum = selectedObjects.reduce((acc, curr) => {
      return acc + parseFloat(curr.output_price || '0');
    }, 0);

    setTotalCost(sum);
  }, [selectedItems, filteredProducts]);

  return (
    <Modal
      id="kt_modal_create"
      tabIndex={-1}
      aria-hidden="true"
      dialogClassName="modal-dialog modal-dialog-centered modal-lg"
      show={show}
      backdrop="static"
      keyboard={false}
    >
      <div className="modal-content">
        <div className="modal-header pb-0 border-0 justify-content-end">
          <div
            className="btn btn-sm btn-icon btn-active-color-primary"
            data-bs-dismiss="modal"
            onClick={onClose}
          >
            <KTSVG
              className="svg-icon-2"
              path="/media/icons/duotune/arrows/arr061.svg"
            />
          </div>
        </div>

        <div className="modal-body scroll-y mx-5 pt-0">
          <div className="text-center mb-13">
            <h1 className="mb-3">Devolver</h1>
          </div>
          <form
            id="kt_modal_generic_form"
            className="form"
            action="#"
            onSubmit={formPackMovement.handleSubmit}
          >
            <Stepper
              headers={stepperHeaders}
              loading={loading}
              onCancel={onClose}
              stepper={stepper}
              textButton={textStepper}
            >
              <div className="w-100 container">
                <div className="row justify-content-center">
                  {/* Detalles de devolución */}
                  <div className="col-7 border border-gray-500 min-h-600px p-5 rounded">
                    <span className="fw-bolder fs-5 text-gray-600">
                      Detalles de devolución
                    </span>
                    <div className="separator border-2 my-4" />

                    {/* Acción */}
                    <div className="mb-4">
                      <label className="fw-bold fs-6 mb-2">Acción</label>
                      <Select
                        isDisabled
                        options={typeActionsOptions}
                        placeholder={'Seleccione'}
                        onChange={handleCustomerChangeType}
                        value={selectedOptionMov}
                        noOptionsMessage={() => <span>No hay registros</span>}
                        menuPortalTarget={document.body}
                        styles={statusSelectModalStyles}
                      />

                      {formPackMovement.touched.is_output &&
                        formPackMovement.errors.is_output && (
                          <div className="text-danger mt-2">
                            {formPackMovement.errors.is_output}
                          </div>
                        )}
                    </div>

                    {/* Tipo */}
                    <div className="mb-4">
                      <label className="required fw-bold fs-6 mb-2">
                        Razón
                      </label>
                      <Select
                        options={filteredMovOptions}
                        placeholder={'Seleccione'}
                        onChange={handleCustomerChangeMov}
                        value={filteredMovOptions.find(
                          (option) =>
                            option.value ===
                            Number(formPackMovement.values.motive_id)
                        )}
                        noOptionsMessage={() => <span>No hay registros</span>}
                        menuPortalTarget={document.body}
                        styles={statusSelectModalStyles}
                      />

                      {formPackMovement.touched.motive_id &&
                        formPackMovement.errors.motive_id && (
                          <div className="text-danger mt-2">
                            {formPackMovement.errors.motive_id}
                          </div>
                        )}
                    </div>

                    {/* Usuario y Fecha */}
                    <div className="row mb-4">
                      <div className="col">
                        <label className="fw-bold fs-6 mb-2">Usuario</label>
                        <input
                          type="text"
                          className="form-control"
                          value={user?.full_name || 'Sin nombre'}
                          disabled
                        />
                      </div>
                      <div className="col">
                        <label className="fw-bold fs-6 mb-2">Fecha</label>
                        <input
                          type="text"
                          className="form-control"
                          value={packageDate}
                          disabled
                        />
                      </div>
                    </div>

                    {/* Motivo */}
                    <div className="mb-4">
                      <label className="required fw-bold fs-6 mb-2">
                        Motivo
                      </label>
                      <textarea
                        className="form-control h-150px"
                        placeholder="Descripción"
                        maxLength={200}
                        {...formPackMovement.getFieldProps('detail')}
                      />
                      {formPackMovement.touched.detail &&
                        formPackMovement.errors.detail && (
                          <div className="text-danger mt-2">
                            {formPackMovement.errors.detail}
                          </div>
                        )}
                    </div>
                  </div>

                  {/* Selección de productos */}
                  <div className="col-4 border border-gray-500 min-h-600px ms-4 p-5 rounded">
                    <span className="fw-bolder fs-5 text-gray-600">
                      Selección de productos
                    </span>
                    <div className="separator border-2 my-4" />

                    {/* Buscador */}
                    <div className="text-center">
                      <a
                        type="button"
                        onClick={() => {
                          setFilteredProducts([]);
                          setSelectedItems([]);
                          fetchPostIccid(data?.id);
                        }}
                        className="btn btn-light-primary mb-3"
                      >
                        Actualizar
                        <i className="fas fa-sync-alt fs-4 ms-2"></i>
                      </a>
                    </div>
                    <div className="mb-4">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Buscar ICCID"
                        value={searchTerm}
                        onChange={(e) => handleSearch(e.target.value)}
                      />
                    </div>

                    {/* Tabla de productos */}
                    <div
                      className="table-responsive"
                      style={{ maxHeight: '400px', overflowY: 'auto' }}
                    >
                      <table className="table align-middle table-row-dashed fs-6 gy-3">
                        <thead>
                          <tr className="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
                            <th scope="col">
                              <input
                                type="checkbox"
                                onChange={handleSelectAll}
                                checked={
                                  selectedItems.length ===
                                    filteredProducts.length &&
                                  filteredProducts.length > 0
                                }
                              />
                            </th>
                            <th scope="col">ICCID</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredProducts.map((item) => (
                            <tr key={item.stock.iccid}>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={selectedItems.includes(item.id)}
                                  onChange={() => toggleSelection(item.id)}
                                  disabled={item.disabled}
                                />
                              </td>
                              <td className={item.disabled ? 'text-muted' : ''}>
                                {item.stock.iccid}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex flex-column justify-content-center align-items-center w-100">
                <h1 className="text-primary fw-bolder text-center">
                  El producto ha sido devuelto al inventario correctamente
                </h1>
                <div className="w-350px rounded mx-auto d-block">
                  <AnimationSucces />
                </div>
              </div>
            </Stepper>
          </form>
        </div>
      </div>
    </Modal>
  );
};
export { DevolverModal };
